import React, {useState} from "react";
import useEditableTableDateCell from "../../../hooks/useEditableTableDateCell";
import useEditableTableTextCell from "../../../hooks/useEditableTableTextCell";
import useEditableTableTextAreaCell from "../../../hooks/useEditableTableTextAreaCell";
import useEditableTableCostCell from "../../../hooks/useEditableTableCostCell";
import { Button, Checkbox, Control, Field, Input, Select } from "@allxsmith/bestax-bulma";
import NominalCodePicker from "../../Settings/NominalCodes/NominalCodePicker";
import TrackingOptionsPicker from "../../Settings/TrackingCategory/TrackingOptionsPicker";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import axios from "axios";
import HideConfirmModal from "./HideConfirmModal";


export default function InvoiceRow({invoice, onChange, onSave, index, onDelete, onApprove, showApproved, onReady,
                                       activeView, onPartList, setSelectedInvoice, setCreditModalOpen, onNominalChange,
                                       codes, trackingOptions, onTrackingOptionChange, onSelectCheck, onCheckClear, selected, onRowDetailSelect,
                                       onHide}){
    let [editable, setEditable] = useState(false);
    let [confirmModalOpen, setConfirmModalOpen] = useState(false)

    const accountOptions = [
        { name: "", value: "BLANK"},
        { name: "Hire", value: "hire_account_code"},
        { name: "Sale", value: "sale_account_code"},
        { name: "Workshop", value: "workshop_account_code"},
        { name: "Deposit", value: "deposit_account_code"},
        { name: "Loan", value: "loan_account_code"},
        { name: "Part", value: "part_account_code"},
        { name: "Court", value: "court_account_code"},
        { name: "Movement", value: "movement_account_code"}
    ];

    const onCheck = e => {
        e.stopPropagation();
        onSelectCheck(invoice);
    };


    const getType = invoice => {
        if(invoice.movement){
            return "Movement "+invoice.movement.id
        }
        else if(invoice.finance_agreement){
            return "Vehicle Sale"
        }
        else if(invoice.part_order){
            return "Part Order "+invoice.part_order.id
        }
        else if(invoice.rental){
            let hireType = invoice.rental.rental_type === 'ST' ? 'SHORT TERM' : 'LONG TERM'
            return hireType+" Rental "+invoice.rental.id
        }
        else{
            return "User Created"
        }
    }

    const getTotal = () => {
        let vatableTotal = invoice.quantity * parseFloat(invoice.amount);
        let vatAmount = vatableTotal * 0.2
        let noVatTotal = invoice.quantity * parseFloat(invoice.no_vat_amount)
        return vatableTotal + vatAmount + noVatTotal;
    }

    const [isLoading, setLoading] = useState(false);
    const [searchData, setSearchData] = useState([]);
    const [, setTypeahead] = useState();

    const handleCustomerChange = customer => {
         const toUpdate = {
                 target: {
                         name: 'customer',
                         value: customer[0]
                 }
         }
         onChange(toUpdate, index);
    };

    const handleContactSearch = e => {
        setLoading(true);
        axios.get(`/api/contacts?contact_type=CC&search=${e}`).then(resp => {
          setSearchData(resp.data.results);
          setLoading(false);
        });
    };

    const handleHide = () => {
        onHide(invoice, !invoice.hide);
    }

    return (
        <tr key={invoice.id}>
            <td>
                {useEditableTableTextCell({
                    propName: "id",
                    value: invoice.id,
                    disabled: true
                })}
            </td>
            {activeView === "movement" &&
                <td>
                    <Input
                        type={"text"}
                        value={invoice.movement.id}
                        disabled={true}
                    />
                </td>
            }
            {/*{activeView === "hire" &&*/}
            {/*    <td>*/}
            {/*        <Form.Input*/}
            {/*            type={"date"}*/}
            {/*            value={invoice.date}*/}
            {/*            disabled={true}*/}
            {/*        />*/}
            {/*    </td>*/}
            {/*}*/}
            <td>
                <AsyncTypeahead
                  useCache={false}
                  id="typeahead"
                  labelKey="display_name"
                  minLength={2}
                  name={"customer"}
                  onSearch={handleContactSearch}
                  onChange={handleCustomerChange}
                  placeholder={"Search Customer"}
                  options={searchData}
                  ref={typeahead => setTypeahead(typeahead)}
                  className="typeahead"
                  isLoading={isLoading}
                  selected={
                    invoice.customer && invoice.customer.id ? [invoice.customer] : []
                  }
                  disabled={!editable}
                />
            </td>
            {/*<td>*/}
            {/*    {useEditableTableTextCell({*/}
            {/*        propName: "",*/}
            {/*        value: getType(invoice),*/}
            {/*        disabled: true*/}
            {/*    })}*/}
            {/*</td>*/}
            {invoice.rental ?
                <td>
                    <Input
                        disabled={!editable}
                        name={"quantity"}
                        value={invoice.quantity}
                        onChange={e => onChange(e, index)}
                    />
                </td> : activeView === "hire" &&
                <td>
                    <Input
                        disabled={true}
                        value={1}
                    />
                </td>
            }
            <td>
                {useEditableTableCostCell({
                    propName: "amount",
                    value: invoice.amount,
                    disabled: (invoice.approved || activeView === "order"),
                    inlineEdit: true,
                    editable,
                    setEditable,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(invoice);
                        setEditable(false)
                    }
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "no_vat_amount",
                    value: invoice.no_vat_amount,
                    disabled: (invoice.approved || activeView === "order"),
                    inlineEdit: true,
                    editable,
                    setEditable,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(invoice);
                        setEditable(false)
                    }
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "vat",
                    value: invoice.amount * 0.2,
                    disabled: true
                })}
            </td>
            <td>
                {useEditableTableCostCell({
                    propName: "total",
                    value: getTotal(),
                    disabled: true
                })}
            </td>
            <td>
                {useEditableTableDateCell({
                    propName: "invoice_date",
                    value: invoice.invoice_date,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(invoice);
                        setEditable(false)
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: invoice.approved
                })}
            </td>
            {/*<td>*/}
            {/*    {useEditableTableDateCell({*/}
            {/*        propName: "payment_date",*/}
            {/*        value: invoice.payment_date,*/}
            {/*        onChange: (e) => onChange(e, index),*/}
            {/*        onSave: () => {*/}
            {/*            onSave(invoice);*/}
            {/*            setEditable(false)*/}
            {/*        },*/}
            {/*        editable,*/}
            {/*        setEditable,*/}
            {/*        inlineEdit: true,*/}
            {/*        disabled: invoice.approved*/}
            {/*    })}*/}
            {/*</td>*/}
            {activeView === "movement" &&
            <td>
                <Select
                  name={"customer_account"}
                  disabled={!editable}
                  value={invoice.customer_account}
                  onChange={(e) => onChange(e, index)}
                >
                  {accountOptions.map((option) => (
                      <option value={option.value}>{option['name']}</option>
                  ))}
                </Select>
            </td>
            }
            <td>
                <TrackingOptionsPicker
                    name={"tracking_option"}
                    value={invoice.tracking_option}
                    options={trackingOptions}
                    onChange={e => onTrackingOptionChange(e, index)}
                    onSave={() => {
                        onSave(invoice);
                        setEditable(false)
                    }}
                    editable={editable}
                    setEditable={setEditable}
                    disabled={invoice.approved || !editable}
                    blank={true}
                    inlineEdit={!invoice.approved}
                />
            </td>
            <td>
                <NominalCodePicker
                    name={"vat_nominal_code"}
                    value={invoice.vat_nominal_code}
                    onChange={(e)=> onNominalChange(e, index)}
                    onSave={()=> {
                        onSave(invoice);
                        setEditable(false);
                    }}
                    editable={editable}
                    setEditable={setEditable}
                    inlineEdit={!invoice.approved}
                    disabled={invoice.approved || !editable}
                    options={codes}
                    blank={true}
                />
            </td>
            <td>
                <NominalCodePicker
                    name={"no_vat_nominal_code"}
                    value={invoice.no_vat_nominal_code}
                    onChange={(e)=> onNominalChange(e, index)}
                    onSave={()=> {
                        onSave(invoice);
                        setEditable(false);
                    }}
                    editable={editable}
                    setEditable={setEditable}
                    inlineEdit={!invoice.approved}
                    disabled={invoice.approved || !editable}
                    options={codes}
                    blank={true}
                />
            </td>
            <td>
                {useEditableTableTextCell({
                    propName: "invoice_number",
                    value: invoice.invoice_number,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(invoice);
                        setEditable(false)
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: invoice.approved
                })}
            </td>
            {(activeView === "movement" || activeView === "order") &&
                <td>
                    <Input
                        type={"number"}
                        name={"customer_paid_amount"}
                        value={invoice.customer_paid_amount}
                        disabled={true}
                        onChange={e => onChange(e, index)}
                    />
                </td>
            }
            <td>
                {useEditableTableTextAreaCell({
                    propName: "description",
                    value: invoice.description,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(invoice);
                        setEditable(false)
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: invoice.approved
                })}
            </td>
            <td>
                {useEditableTableTextAreaCell({
                    propName: "comments",
                    value: invoice.comments,
                    onChange: (e) => onChange(e, index),
                    onSave: () => {
                        onSave(invoice);
                        setEditable(false)
                    },
                    editable,
                    setEditable,
                    inlineEdit: true,
                    disabled: invoice.approved
                })}
            </td>
            {showApproved &&
                <td>
                    <Input
                        disabled={true}
                        value={invoice.approver ? invoice.approver.first_name+" "+invoice.approver.last_name : ""}
                    />
                </td>
            }
            {activeView === "hire" &&
                <td onClick={e => e.stopPropagation()}>
                  <Field>
                    <Control className="table-checkbox">
                      <Checkbox
                          checked={selected}
                          type="checkbox"
                          onClick={onCheck}
                          readOnly
                      />
                    </Control>
                  </Field>
                </td>
            }
            {activeView === "order" &&
                <td>
                    <Button
                        color={"warning"}
                        onClick={() => onPartList(index)}
                    >
                        Show Parts
                    </Button>
                </td>
            }
            {activeView === "order" &&
                <td>
                    <Button
                        color={"warning"}
                        onClick={() => window.open(`/editpartorder/${invoice.part_order.id}`, "_self")}
                    >
                        Go To
                    </Button>
                </td>
            }
            {(activeView === "hire" && invoice.rental) ?
                <td>
                    <Button
                        color={"warning"}
                        onClick={() => window.open(`/editrental/${invoice.rental.id}`, "_self")}
                    >
                        Go To
                    </Button>
                </td> : <td></td>
            }
            {(activeView === "hire" && invoice.rental) ?
                <td>
                    <Button
                        color={"warning"}
                        onClick={() => onRowDetailSelect(index)}
                    >
                        Details
                    </Button>
                </td> : <td></td>
            }
            {invoice.approved &&
                <td>
                    <Button
                        color={"warning"}
                        onClick={()=> {
                                setSelectedInvoice(invoice);
                                setCreditModalOpen(true);
                        }}
                    >
                        Credit
                    </Button>
                </td>
            }
            {!showApproved && !invoice.approved && !invoice.ready_to_invoice && !invoice.hide &&
                 <td>
                    <Button
                        color={"info"}
                        onClick={() => onReady([invoice])}
                    >
                        R
                    </Button>
                 </td>
            }
            {!showApproved && !invoice.approved && invoice.ready_to_invoice && !invoice.hide &&
                <td>
                    <Button
                        color={"success"}
                        onClick={() => onApprove([invoice])}
                    >
                        A
                    </Button>
                </td>
            }
            {!invoice.approved && !invoice.hide &&
                <td>
                    <Button
                        color={"danger"}
                        onClick={() => setConfirmModalOpen(true)}
                    >
                        HIDE
                    </Button>
                </td>
            }
            {!invoice.approved && invoice.hide &&
                <td>
                    <Button
                        color={"danger"}
                        onClick={() => setConfirmModalOpen(true)}
                    >
                        UNHIDE
                    </Button>
                </td>
            }
            <HideConfirmModal
                open={confirmModalOpen}
                setOpen={setConfirmModalOpen}
                onConfirm={handleHide}
            />
        </tr>
    );


}